import { createContext } from 'dw-neit-rc-component-context';
export var StaticContext = createContext(null);
export var GridContext = createContext(null);